// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/fuel-tank-management.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/fuel-tank-management/fuel-tank-management.js';

mount([g0]);
